<template>
  <aside class="menu-empleado">
    <h3>Empleado</h3>
    <ul>
      <li>
        <router-link to="/Empleado/panelEmpl">
          <i class="bi bi-house-fill icon"></i> Inicio
        </router-link>
      </li>
      <li>
        <router-link to="/Empleado/Reservacion">
          <i class="bi bi-calendar-check icon"></i> Reservacion
        </router-link>
      </li>
      <li>
        <router-link to="/Empleado/Pagos">
          <i class="bi bi-cash-coin icon"></i> Pago
        </router-link>
      </li>
      <li>
        <router-link to="/Empleado/Conductores">
          <i class="bi bi-people icon"></i> Conductores
        </router-link>
      </li>
      <li>
        <router-link to="/Empleado/Autos">
          <i class="bi bi-car-front icon"></i> Autos
        </router-link>
      </li>
      <li>
        <router-link to="/Empleado/Reporte">
          <i class="bi bi-calendar-check icon"></i> Reportes
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: "MenuEmpleado",
};
</script>

<style scoped>
.menu-empleado {
  width: 200px;
  background-color: rgb(61, 61, 61);
  color: white;
  padding-top: 20px;
  height: 100vh;
  position: fixed;
  left: 0;
}

.menu-empleado h3 {
  text-align: center;
  margin: 0;
  padding: 10px 0;
}

.menu-empleado ul {
  list-style: none;
  padding: 0;
}

.menu-empleado li {
  padding: 10px;
}

.menu-empleado li a {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.menu-empleado li a:hover {
  background-color: #495057;
  border-radius: 4px;
}

/* Añade un margen a la derecha de los íconos */
.icon {
  margin-right: 8px; /* Ajusta el valor según la separación que desees */
}
</style>
